import { Component } from '@angular/core';
import '@maersk-global/mds-components-core/mc-tag';
import '@maersk-global/mds-components-core/mc-popover';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ButtonWithConfirmationComponent } from '../../shared-components/button-with-confirmation/button-with-confirmation.component';
import { RetriggerRequest, RetriggerStarSwatRequest, DeleteWorkOrderBulkRequest } from '../../models/bulk-workorder-actions.model';
import { AppSupportService } from '../../services/app-support.service';
import { catchError, map, Observable } from 'rxjs';
import { RouterModule } from '@angular/router';
import { ToastrService } from '../../services/toastr-service';
import { ApplicationtTextService } from '../../services/application-text.service';
import { RegexConstants } from '../../RegexConstants';
import { AemsMultilineTagInputComponent } from '../../shared-components/aems-multiline-tag-input/aems-multiline-tag-input.component';
import { AuthPolicies } from '../../auth/auth-policies';
interface RetriggerRequestViewModel {
  workOrderId: string;
  status: string;
}
@Component({
  selector: 'app-retrigger-work-order',
  imports: [FormsModule, ButtonWithConfirmationComponent, RouterModule, AemsMultilineTagInputComponent],
  templateUrl: './retrigger-work-order.component.html',
  styleUrls: ['./retrigger-work-order.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RetriggerWorkOrderComponent {
  // Holds manually entered work orders
  retiggerResult: RetriggerRequestViewModel[] = [];
  workOrderNumbers: string[] = []; // Stores work order numbers entered manually
  deleteRemarkText: string = ''; // Stores the remark text for deletion
  regexConstants = RegexConstants; // Expose regex constants for use in the template

  constructor(
    private appSupportService: AppSupportService,
    private toastrService: ToastrService,
    private appTextService: ApplicationtTextService,
    protected authPolicies: AuthPolicies,
  ) {}

  onDeleteClicked(): () => Observable<any> {
    return () => {
      const submittedWorkOrderNumbers = [...this.workOrderNumbers];
      const deleteRequest: DeleteWorkOrderBulkRequest = {
        maintenanceOrderToDeletes: submittedWorkOrderNumbers.map((workOrderId) => ({
          maintenanceOrderNumber: workOrderId,
          maintenanceOrderRemarkText: this.deleteRemarkText,
        })),
      };
      return this.appSupportService.deleteWorkOrder(deleteRequest).pipe(
        map((x) => {
          this.toastrService.showToastr(this.appTextService.workOrderDeletedSuccessfully, 'success');
          this.workOrderNumbers = []; // Clear the work order numbers after deletion
        }),
        catchError((err) => {
          this.toastrService.showToastr(this.appTextService.workOrderDeletionFailed + err.error.errorMessage, 'error');
          throw err;
        }),
      );
    };
  }

  onRetriggerStarSwatClicked(): () => Observable<any> {
    return () => {
      this.retiggerResult = [];
      const submittedWorkOrderNumbers = [...this.workOrderNumbers];
      const request: RetriggerStarSwatRequest = {
        maintenanceOrderNumbers: submittedWorkOrderNumbers.map(Number),
      };
      return this.appSupportService.retriggerStarSwatWorkOrders(request).pipe(
        map(() => {
          this.retiggerResult = submittedWorkOrderNumbers.map((workorderId) => ({
            workOrderId: workorderId,
            status: 'Success',
          }));
          this.workOrderNumbers = [];
          this.toastrService.showToastr(this.appTextService.allWORetriggeredSuccessfully, 'success');
        }),
        catchError((err) => {
          this.toastrService.showToastr(err.error?.errorMessage || 'Retrigger failed', 'error');
          throw err;
        }),
      );
    };
  }

  onRetriggerClicked(): () => Observable<any> {
    return () => {
      this.retiggerResult = [];
      const submittedWorkOrderNumbers = [...this.workOrderNumbers];
      const retriggerRequest: RetriggerRequest = {
        maintenanceOrderNumbers: submittedWorkOrderNumbers,
        jobName: 'SAP_PURCHASE_ORDER_RETRIGGER_REQUEST',
      };
      return this.appSupportService.retriggerWorkOrders(retriggerRequest).pipe(
        catchError((err) => {
          if (err.error.detailedErrors && err.error.detailedErrors.length > 0) {
            const maintenanceOrderError = err.error.detailedErrors.find((error: any) => error.field === 'MaintenanceOrderNumbers');
            let errorWorkordersId: string[] = maintenanceOrderError.value.split(',');
            this.retiggerResult = submittedWorkOrderNumbers.map((workOrderId) => {
              if (errorWorkordersId.includes(workOrderId)) {
                return {
                  workOrderId: workOrderId,
                  status: 'Failed ' + err.error.errorMessage,
                };
              } else {
                return {
                  workOrderId: workOrderId,
                  status: 'Success',
                };
              }
            });
            if (maintenanceOrderError) {
              this.toastrService.showToastr(`${err.error.errorMessage}: ${maintenanceOrderError.value}`, 'error');
            }
          } else {
            this.toastrService.showToastr(this.appTextService.WorkOrderNotInCorrectFormat, 'error');
          }
          throw err;
        }),
        map((x) => {
          this.retiggerResult = submittedWorkOrderNumbers.map((workorderId) => ({
            workOrderId: workorderId,
            status: 'Success',
          }));
          this.workOrderNumbers = [];
          this.toastrService.showToastr(this.appTextService.allWORetriggeredSuccessfully, 'success');
        }),
      );
    };
  }
}
